import { observer } from 'mobx-react';
import React from 'react';
import { Spinner, SpinnerSize, Stack, Text } from '@fluentui/react';
import EntityNavigator from '../components/controls/EntityNavigator';
import { CombinedOutlookLocationViewer } from './CombinedSearchResultsStateOutlook';
import LegalEntityRootFolder from './LegalEntityRootFolder';

export interface ICombinedSearchResultsOutlookProps {
	state: CombinedOutlookLocationViewer;
}

class CombinedSearchResultsEntityNav extends React.Component<
	ICombinedSearchResultsOutlookProps,
	{}
> {
	render() {
		if (this.props.state.loading) {
			return <Spinner size={SpinnerSize.large} />;
		}

		if (this.props.state.allItems === null) return <></>;

		if (!this.props.state.allItems?.any && this.props.state.orphanResults.documentStates.length === 0)
			return <Text>No results found.</Text>;

		return (
			<Stack>
				{this.getEntityResults()}
				{this.getSiteResults()}
				{this.getOrphanDocumentResults()}
			</Stack>
		);
	}

	private getSiteResults(): React.ReactNode {
		if (
			this.props.state.siteResults.documentViewers &&
			this.props.state.siteResults.documentViewers.length > 0
		) {
			return (
				<Stack>
					<EntityNavigator state={this.props.state.siteResults} />
				</Stack>
			);
		}
	}

	private getOrphanDocumentResults(): React.ReactNode {
		if (
			!this.props.state.orphanResults.loading &&
			this.props.state.orphanResults.documentStates.length > 0
		) {
			return (
				<Stack>
					<LegalEntityRootFolder
						state={this.props.state.orphanResults}
					/>
				</Stack>
			);
		}
	}

	private getEntityResults(): React.ReactNode {
		return this.props.state.entityNavigators.map((e) => (
			<EntityNavigator key={Math.random()} state={e} />
		));
	}
}

export default observer(CombinedSearchResultsEntityNav);
